export type OrderItemQuantitySource = {
  id: string | number;
  quantity: number;
  billed_quantity?: number;
  cancelled_quantity?: number;
  returned_quantity?: number;
};

/** Remaining qty = quantity - billed - cancelled - returned (leading number in `1 (1)`). */
export const getRemainingQty = (item: OrderItemQuantitySource): number =>
  item.quantity -
  ((item.billed_quantity ?? 0) +
    (item.cancelled_quantity ?? 0) +
    (item.returned_quantity ?? 0));

export const getSelectableItemIds = <T extends OrderItemQuantitySource>(
  orderItems: T[]
): Array<T["id"]> =>
  orderItems.filter((item) => getRemainingQty(item) > 0).map((item) => item.id);

/** Map of item id → remaining qty for every selectable row; empty string for non-selectable. */
export const buildFullBilledQtyMap = (
  orderItems: OrderItemQuantitySource[]
): Record<string, number | string> =>
  orderItems.reduce<Record<string, number | string>>((acc, item) => {
    const remaining = getRemainingQty(item);
    acc[String(item.id)] = remaining > 0 ? remaining : "";
    return acc;
  }, {});

export const buildEmptyBilledQtyMap = (
  orderItems: OrderItemQuantitySource[]
): Record<string, string> =>
  orderItems.reduce<Record<string, string>>((acc, item) => {
    acc[String(item.id)] = "";
    return acc;
  }, {});
